import { render, staticRenderFns } from "./FlowChart.vue?vue&type=template&id=2ecb97d5"
import script from "./FlowChart.vue?vue&type=script&lang=js"
export * from "./FlowChart.vue?vue&type=script&lang=js"
import style0 from "./FlowChart.vue?vue&type=style&index=0&id=2ecb97d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports